module.exports = __webpack_public_path__ + "img/ellipse2.9ef6bcb7.svg";